module.exports = __webpack_public_path__ + "68b791cf4a70cb39ce52ed72686a3cf7.svg";